<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a dp sensor" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <ng-container matColumnDef="fmea_findings_closed_text">
                <th mat-header-cell *matHeaderCellDef> FMEA Findings Closed? </th>
                <td mat-cell *matCellDef="let element"> {{element.fmea_findings_closed_text}} </td>
            </ng-container>

            <ng-container matColumnDef="tested_text">
                <th mat-header-cell *matHeaderCellDef> Tested? </th>
                <td mat-cell *matCellDef="let element"> {{element.tested_text}} </td>
            </ng-container>

            <ng-container matColumnDef="trail_updated_text">
                <th mat-header-cell *matHeaderCellDef> Trial Updated? </th>
                <td mat-cell *matCellDef="let element"> {{element.trail_updated_text}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailDocumentModification(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>



